import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

export default function Redirect_task_mang() {
  const navigate = useNavigate();
    
      useEffect(() => {
        navigate('/project_details'); 
      }, [navigate]); 
    
      return null; 
}
